import { lazy, Suspense } from 'react';
/// Components
import Index from "./jsx";
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
    });
});

function App(props) {
    let routes = (  
        <Switch>
              <Route exact path="/" render={() => <Redirect to="/login" />} />
            <Route path='/login' component={Login} />
            <Route path='/page-register' component={SignUp} />
            <Route path='/page-forgot-password' component={ForgotPassword} />
        </Switch>
    );

    if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>  
                }>
                    <Index />
                </Suspense>
            </>
        );
    } else {
        return (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }>
                    {routes}
                </Suspense>
            </div>
        );
    }
};

const mapStateToProps = () => {
    // ✅ Check sessionStorage instead of Redux/dispatch
    const userDetails = sessionStorage.getItem("userDetails");
    return {
        isAuthenticated: !!userDetails, // true if exists, false if not
    };
};

export default withRouter(connect(mapStateToProps)(App));

// import { lazy, Suspense, useEffect } from 'react';
// /// Components
// import Index from "./jsx";
// import { connect, useDispatch } from 'react-redux';
// import {  Route, Switch, withRouter } from 'react-router-dom';
// // action
// import { checkAutoLogin } from './services/AuthService';
// import { isAuthenticated } from './store/selectors/AuthSelectors';
// /// Style
// import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
// import "./css/style.css";
// const SignUp = lazy(() => import('./jsx/pages/Registration'));
// const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
// const Login = lazy(() => {
//     return new Promise(resolve => {
//     setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
//   });
// });

// function App (props) {
//     const dispatch = useDispatch();
//     useEffect(() => {
//         checkAutoLogin(dispatch, props.history);
//     }, [dispatch, props.history]);
    
//     let routes = (  
//         <Switch>
//             <Route path='/login' component={Login} />
//             <Route path='/page-register' component={SignUp} />
//             <Route path='/page-forgot-password' component={ForgotPassword} />
//         </Switch>
//     );
//     if (props.isAuthenticated) {
// 		return (
// 			<>
//                 <Suspense fallback={
//                     <div id="preloader">
//                         <div className="sk-three-bounce">
//                             <div className="sk-child sk-bounce1"></div>
//                             <div className="sk-child sk-bounce2"></div>
//                             <div className="sk-child sk-bounce3"></div>
//                         </div>
//                     </div>  
//                    }
//                 >
//                     <Index / >
//                 </Suspense>
//             </>
//         );
	
// 	}else{
// 		return (
// 			<div className="vh-100">
//                 <Suspense fallback={
//                     <div id="preloader">
//                         <div className="sk-three-bounce">
//                             <div className="sk-child sk-bounce1"></div>
//                             <div className="sk-child sk-bounce2"></div>
//                             <div className="sk-child sk-bounce3"></div>
//                         </div>
//                     </div>
//                   }
//                 >
//                     {routes}
//                 </Suspense>
// 			</div>
// 		);
// 	}
// };

// const mapStateToProps = (state) => {
//     return {
//         isAuthenticated: isAuthenticated(state),
//     };
// };

// export default withRouter(connect(mapStateToProps)(App)); 

